<template>
  <el-row class="top-navigator">
    <el-col :span="15" :offset="3">
      <el-menu
        mode="horizontal"
        :default-active="$route.path"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="/">
          <el-image style="width: 60px; height: 60px; border-radius: 10px;" :src="avatar">
          </el-image>
        </el-menu-item>
        <el-menu-item index="/home"><router-link to="/home">主页</router-link></el-menu-item>
        <el-menu-item index="/userList"><router-link to="/userList">用户管理</router-link></el-menu-item>
        <el-menu-item index="/providerList"><router-link to="/providerList">代理商管理</router-link></el-menu-item>
        <el-menu-item index="/veteranList"><router-link to="/veteranList">退役军人认证</router-link></el-menu-item>
        <el-menu-item index="/payList"><router-link to="/payList">收入明细</router-link></el-menu-item>
        <el-menu-item index="/cashbackList"><router-link to="/cashbackList">返现明细</router-link></el-menu-item>
        <el-menu-item index="/tools"><router-link to="/tools">常用工具</router-link></el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="3" :offset="3" class="user-info">
      <span>你好, {{ username }}</span>
      <span class="logout" @click="doLogout" v-if="username != '匿名用户'">登出</span>
    </el-col>
  </el-row>
</template>

<script>
import avatar from '@/assets/logo.png'

export default {
  name: 'top-navigator',
  computed: {
    username() {
      if (this.$store.state.CurrentUser == '匿名用户') {
        this.$router.push('/login')
      }
      return this.$store.state.CurrentUser
    }
  },
  data: () => {
    return {
      avatar: avatar,
    }
  },
  methods: {
    doLogout() {
      this.$store.commit('update', ['Authorization', '']);
      this.$store.commit('update', ['CurrentUser', '匿名用户']);
      this.$router.push('/login')
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.top-navigator {
  font-weight: bolder;
  background: #545c64;
  height: 60px;
  line-height: 60px;
}
.user-info {
  color: white;
  font-size: 10px;
}
a {
  text-decoration: none;
  color: white;
}
.logout {
  margin-left: 15px;
  font-size: 10px;
  color: #999999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopNavigator.vue